module.exports = __webpack_public_path__ + "assets/images/outfit-04.0927862c08c6b970dd8efdec9ed992a4.svg";